import axios from "axios";
import { API_BASE_URL } from "../constants/constants.js";

// Create Axios instance
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});

/* ================= REQUEST INTERCEPTOR ================= */
apiClient.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

/* ================= RESPONSE INTERCEPTOR ================= */
// apiClient.interceptors.response.use(
//   (response) => {
//     return response;
//   },
//   (error) => {
//     // 🔥 FIX: Ignore business-valid 425
//     if (error.response?.status === 425) {
      
//       return Promise.reject(error); // silent pass-through
//     }

//     if (error.response) {
//       console.error("Response error:", error.response.data);
//     } else if (error.request) {
//       console.error("No response from server:", error.request);
//     } else {
//       console.error("Error setting up request:", error.message);
//     }

//     return Promise.reject(error);
//   }
// );



apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 425) {
      return Promise.resolve({
        data: [],
        status: 200,
        config: error.config,
        headers: error.response.headers,
      });
    }

    console.error("API Error:", error);
    return Promise.reject(error);
  }
);


export default apiClient;






















/*import axios from 'axios';
import {API_BASE_URL}  from '../constants/constants.js';
// Create an Axios instance with the base URL
const apiClient = axios.create({
  //baseURL: 'https://ns.srv851107.hstgr.cloud',

  // baseURL: 'https://po.sriyansh.co.in',

  baseURL: API_BASE_URL, // Use the base URL from config
  timeout: 10000, // optional, sets a timeout for requests
  headers: {
    'Content-Type': 'application/json', // optional, set default headers
  },
});

// Request interceptor to handle additional configurations
apiClient.interceptors.request.use(
  (config) => {
    // Add Authorization token if needed
    // const token = localStorage.getItem('authToken'); // example token storage
    // if (token) {
    //   config.headers.Authorization = `Bearer ${token}`;
    // }
    return config;
  },
  (error) => {
    // Handle request errors
    return Promise.reject(error);
  }
);

// Response interceptor to handle responses globally
apiClient.interceptors.response.use(
  (response) => {
    // Handle successful responses
    return response;
  },
  (error) => {
    // Handle errors globally
    if (error.response) {
      // Server responded with a status other than 2xx
      console.error('Response error:', error.response.data);
    } else if (error.request) {
      // No response received
      console.error('No response from server:', error.request);
    } else {
      // Other errors
      console.error('Error setting up request:', error.message);
    }
    return Promise.reject(error);
  }
);

export default apiClient;*/

